import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { PlatformSource } from '@/api/types/common.types';
import { usePageContext } from '@/contexts/PageContext';
import { getPlatformSource } from '@/utils/getPlatformSource';
import { useMobileDetect } from '@/hooks/useMobileDetect';

// Prefer deviceType from PageContext, it comes from SSR pageProps (user-agent from headers)
// so SSR and client return the same value which
// keeps Apollo cache-hit working on the "source" key
// Fallback to useMobileDetect when no Provider is mounted (unit tests, etc)
export function usePlatformSource() {
  const { isWebView } = useBridgeState();
  const { deviceType } = usePageContext();
  const { isDesktop } = useMobileDetect();

  if (isWebView) return PlatformSource.App;
  if (deviceType !== undefined) return getPlatformSource(deviceType);
  return isDesktop ? PlatformSource.Desktop : PlatformSource.Mobile;
}
